import React, { useState } from 'react';
import { ContentSectionWrap } from '../common-styles.styles';

const AboutCityCountry = props => {
  const { heading, color, aboutInfo, isDweb = false } = props;
  const [expandtext, setExpandtext] = useState(false);
  const handleExpandText = () => {
    setExpandtext(!expandtext);
  };

  return (
    <ContentSectionWrap className={color} isDweb={isDweb}>
      <div className="marginB15">
        <span className="contentHead">{heading}</span>
      </div>
      <div className="contentSection">
        <div onClick={handleExpandText} className="marginB10 curPointFlt">
          <div
            className={`font10 ${isDweb ? 'greyCnt' : 'marginB4'}`}
            dangerouslySetInnerHTML={{ __html: aboutInfo }}
          ></div>
        </div>
      </div>
    </ContentSectionWrap>
  );
};

export default AboutCityCountry;
